import React, {useEffect, useState} from 'react';
import {Col, Form, Modal, Row} from "react-bootstrap";
import success from "../../assets/icons/success.png";
import fail from "../../assets/icons/fail.png";
import show_passwd from "../../assets/icons/show_passwd.png";
import hide_passwd from "../../assets/icons/hide_passwd.png";

export default function ChangePage(props) {
    const [newEmail, setNewEmail] = useState('')
    const [oldPasswd, setOldPasswd] = useState('')
    const [newPasswd, setNewPasswd] = useState('')
    const [repeatNewPasswd, setRepeatNewPasswd] = useState('')
    const [errorsEmail, setErrorsEmail] = useState('')
    const [passwdError, setPasswdError] = useState({old: '', new: '', repeatNew: ''})
    const [message, setMessage] = useState('')
    const [infoIcon, setInfoIcon] = useState(success)
    const [showPasswd, setShowPasswd] = useState({old: false, new: false, repeatNew: false})
    const [infoModalShow, setInfoModalShow] = useState(false)
    const [askModalShow, setAskModalShow] = useState(false)

    function changeEmail(e) {
        e.preventDefault()
        if (errorsEmail === '') {
            const changeEmail = {"newEmail": newEmail}
            fetch('api/ResetEmail', {
                method: 'PUT',
                headers: !props.token ? {} : {
                    'Authorization': `Bearer ${props.token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(changeEmail)
            }).then((response) => {
                if (response.ok) {
                    setMessage('E-mail успешно изменен')
                    setInfoIcon(success)
                    setAskModalShow(false)
                    setInfoModalShow(true)
                    setNewEmail('')
                } else {
                    setMessage('Ошибка изменения e-mail')
                    setInfoIcon(fail)
                    setAskModalShow(false)
                    setInfoModalShow(true)
                }
            })
        }
    }

    function changePasswd(e) {
        e.preventDefault()
        if (passwdError.old === '' && passwdError.new === '' && passwdError.repeatNew === '') {
            const changePasswd = {oldPass: oldPasswd, newPass: newPasswd}
            fetch('api/resetPassword', {
                method: 'PUT',
                headers: !props.token ? {} : {
                    'Authorization': `Bearer ${props.token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(changePasswd)
            }).then((response) => {
                if (response.ok) {
                    setMessage('Пароль успешно изменен')
                    setInfoIcon(success)
                    setInfoModalShow(true)
                    setOldPasswd('')
                    setNewPasswd('')
                    setRepeatNewPasswd('')
                } else {
                    setMessage('Ошибка изменения пароля')
                    setInfoIcon(fail)
                    setInfoModalShow(true)
                }
            })
        }
    }

    function infoModal(props) {
        return (
            <Modal show={props}
                   backdrop="true"
                   className='info-modal'
                   keyboard={false}
                   animation={false}
                   onHide={() => setInfoModalShow(false)}
                   centered>
                <Modal.Header>
                    <img src={infoIcon} alt='success'/>
                </Modal.Header>
                <Modal.Body>
                    <div className="message">{message}</div>
                </Modal.Body>
            </Modal>
        );
    }

    function askModal(props) {
        return (
            <Modal show={props}
                   backdrop="true"
                   className='ask-del-modal'
                   keyboard={false}
                   animation={false}
                   onHide={() => setAskModalShow(false)}
                   centered>
                <Modal.Header>
                    <Modal.Title>Вы действительно хотите изменить свой e-mail?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='btn-row'>
                        <Col>
                            <button className='confirm-btn' onClick={() => setAskModalShow(false)}>Нет</button>
                        </Col>
                        <Col>
                            <button className='confirm-btn' onClick={(e) => changeEmail(e)}>Да</button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }

    function checkEmailValid(value) {
        if (newEmail === '')
            return ('Заполните поле!')
        let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!regEmail.test(value)) {
            return ('Некорректный email!')
        }
        return ''
    }

    function checkPasswdValid(value) {
        if (value.length < 5)
            return 'Пароль должен содержать минимум 5 символов!'
        else
            return ''
    }

    useEffect(() => {
        if (oldPasswd === '' && newPasswd === '' && repeatNewPasswd === '')
            setPasswdError({old: '', new: '', repeatNew: ''})
        else
            setPasswdError({
                old: oldPasswd === '' ? 'Заполните поле!' : '',
                new: passwdError.new,
                repeatNew: passwdError.repeatNew
            })
    }, [oldPasswd])

    useEffect(() => {
        if (oldPasswd === '' && newPasswd === '' && repeatNewPasswd === '')
            setPasswdError({old: '', new: '', repeatNew: ''})
        else
            setPasswdError({
                old: passwdError.old,
                new: newPasswd === '' ? 'Заполните поле!' : (''),
                repeatNew: passwdError.repeatNew
            })
    }, [newPasswd])

    useEffect(() => {
        if (oldPasswd === '' && newPasswd === '' && repeatNewPasswd === '')
            setPasswdError({old: '', new: '', repeatNew: ''})
        else
            setPasswdError({
                old: passwdError.old,
                new: passwdError.new,
                repeatNew: repeatNewPasswd === '' ? (newPasswd === '' ? '' : 'Заполните поле!') : (newPasswd === '' ? '' : (newPasswd === repeatNewPasswd ? '' : 'Пароли не совпадают!'))
            })
    }, [repeatNewPasswd])


    useEffect(() => {
        if (infoModalShow) {
            setTimeout(() => setInfoModalShow(false), 2000)
        }
    }, [infoModalShow])


    useEffect(() => {
        document.getElementById('old').type = showPasswd.old ? 'text' : 'password'
        document.getElementById('new').type = showPasswd.new ? 'text' : 'password'
        document.getElementById('repeatNew').type = showPasswd.repeatNew ? 'text' : 'password'
    }, [showPasswd])


    return <Row id='change-page-row'>
        {infoModal(infoModalShow)}
        {askModal(askModalShow)}
        <Col id='email-block'>
            <Row className="block-label">Изменить e-mail</Row>
            <Row className="back-block">
                <Form>
                    <Form.Group>
                        <Form.Label>Введите новый e-mail</Form.Label>
                        <Form.Control placeholder='e-mail'
                                      className={errorsEmail !== '' ? 'error' : ''}
                                      value={newEmail}
                                      onBlur={() => setErrorsEmail(checkEmailValid(newEmail))}
                                      onChange={(e) => setNewEmail(e.target.value)}></Form.Control>
                        <span>{errorsEmail}</span>
                    </Form.Group>
                    <button onClick={((e) => {
                        e.preventDefault()
                        setAskModalShow(true)
                    })}>Изменить
                    </button>
                </Form>
            </Row>
        </Col>
        <Col id='password-block'>
            <Row className="block-label">Изменить пароль</Row>
            <Row className="back-block">
                <Form>
                    <Form.Group className='passwd-form'>
                        <Form.Label>Введите старый пароль</Form.Label>
                        <Form.Control placeholder='пароль'
                                      className={passwdError.old !== '' ? 'error' : ''}
                                      value={oldPasswd}
                                      type='password'
                                      onBlur={() => setPasswdError({
                                          old: passwdError.old === '' ? checkPasswdValid(oldPasswd) : passwdError.old,
                                          new: passwdError.new,
                                          repeatNew: passwdError.repeatNew
                                      })}
                                      id='old'
                                      onChange={(e) => setOldPasswd(e.target.value)}
                        ></Form.Control>
                        <button className='eye-btn' onClick={(e) => {
                            e.preventDefault()
                            setShowPasswd({
                                old: !showPasswd.old,
                                new: showPasswd.new,
                                repeatNew: showPasswd.repeatNew
                            })
                        }}><img src={showPasswd.old ? show_passwd : hide_passwd} alt='eye'/></button>
                        <span>{passwdError.old}</span>
                    </Form.Group>
                    <Form.Group className='passwd-form'>
                        <Form.Label>Введите новый пароль</Form.Label>
                        <Form.Control placeholder='пароль'
                                      className={passwdError.new !== '' ? 'error' : ''}
                                      value={newPasswd}
                                      id='new'
                                      onBlur={() => setPasswdError({
                                          old: passwdError.old,
                                          new: passwdError.new === '' ? checkPasswdValid(newPasswd) : passwdError.new,
                                          repeatNew: passwdError.repeatNew
                                      })}
                                      type='password'
                                      onChange={(e) => setNewPasswd(e.target.value)}
                        ></Form.Control>
                        <button className='eye-btn' onClick={(e) => {
                            e.preventDefault()
                            setShowPasswd({
                                old: showPasswd.old,
                                new: !showPasswd.new,
                                repeatNew: showPasswd.repeatNew
                            })
                        }}><img src={showPasswd.new ? show_passwd : hide_passwd} alt='eye'/></button>
                        <span>{passwdError.new}</span>
                    </Form.Group>
                    <Form.Group className='passwd-form'>
                        <Form.Label>Повторите новый пароль</Form.Label>
                        <Form.Control placeholder='пароль'
                                      className={passwdError.repeatNew !== '' ? 'error' : ''}
                                      value={repeatNewPasswd}
                                      type='password'
                                      id='repeatNew'
                                      onBlur={() => setPasswdError({
                                          old: passwdError.old,
                                          new: passwdError.new,
                                          repeatNew: passwdError.repeatNew === '' ? checkPasswdValid(repeatNewPasswd) : passwdError.repeatNew
                                      })}
                                      onChange={(e) => setRepeatNewPasswd(e.target.value)}>
                        </Form.Control>
                        <button className='eye-btn' onClick={(e) => {
                            e.preventDefault()
                            setShowPasswd({
                                old: showPasswd.old,
                                new: showPasswd.new,
                                repeatNew: !showPasswd.repeatNew
                            })
                        }}><img src={showPasswd.repeatNew ? show_passwd : hide_passwd} alt='eye'/></button>
                        <span>{passwdError.repeatNew}</span>
                    </Form.Group>
                    <button onClick={(e) => changePasswd(e)}>Сохранить пароль</button>
                </Form>
            </Row>
        </Col>
    </Row>
}
